var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "k-between-input-container" },
    [
      _c("v-text-field", {
        ref: "min-input",
        staticClass: "k-filter-v-input",
        attrs: {
          label: "Min",
          value: _vm.minValue,
          type: _vm.inputType,
          "hide-details": "",
          dense: "",
          box: "",
          "background-color": "#fff"
        },
        on: { input: _vm.handleMinInput, keydown: _vm.handleMinKeydown }
      }),
      _vm._v(" "),
      _c("v-text-field", {
        ref: "max-input",
        staticClass: "k-filter-v-input",
        attrs: {
          label: "max",
          value: _vm.maxValue,
          type: _vm.inputType,
          error: _vm.hasError,
          "hide-details": "",
          dense: "",
          box: "",
          "background-color": "#fff"
        },
        on: { input: _vm.handleMaxInput, keydown: _vm.handleMaxKeydown }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }